<template>
    <ul class="filter" v-if="showContentType || showMarket || showSolution">
        <li class="filter__item">
                <div class="filter__item-first">{{ dictionary.FilterArticles }}</div>
            </li>
        <li class="filter__item" v-if="markets && showMarket">
            <label for="marketFilter" class="sr-only">{{ dictionary.ArticlesMarkets }}</label>
            <select id="marketFilter" v-model="market" :disabled="isLoading">
                <option value="All">{{ dictionary.ArticlesMarkets }}</option>
                <option v-for="market in markets" :key="market.Key" :value="market.Key">{{
                    market.Name
                }}</option>
            </select>
        </li>
        <li class="filter__item" v-if="solutions && showSolution">
            <label for="solutionFilter" class="sr-only">{{ dictionary.ArticlesSolutions }}</label>
            <select id="solutionFilter" v-model="solution" :disabled="isLoading">
                <option value="All">{{ dictionary.ArticlesSolutions }}</option>
                <option v-for="solutionItem in solutions" :key="solutionItem.Key" :value="solutionItem.Key">{{
                    solutionItem.Name
                }}
                </option>
            </select>
        </li>
        <li class="filter__item" v-if="contentTypes && showContentType">
            <label for="contentTypeFilter" class="sr-only">{{ dictionary.ArticlesContentTypes }}</label>
            <select id="contentTypeFilter" v-model="contentType" :disabled="isLoading">
                <option value="All">{{ dictionary.ArticlesContentTypes }}</option>
                <option v-for="contentType in contentTypes" :key="contentType.Key" :value="contentType.Key">{{
                    contentType.Name
                }}</option>
            </select>
        </li>
        <li class="filter__item" v-if="hasFilterApplied">
            <button type="button" @click="resetFilter">{{ dictionary.ArticlesResetFilter }}</button>
        </li>
    </ul>
    <ul class="articles-list__items">
        <li v-for="article in articles" :key="article.Url">
            <article class="article-item">
                <a :href="article.Url" class="article-item__link">
                    <div class="article-item__inner">
                        <div class="article-item__image">
                            <ResponsiveImage v-if="article.ImageForVue != null" :imageModel="article.ImageForVue" />
                        </div>
                        <div class="article-item__text">
                            <div class="article-item__tags" v-if="article.marketTag || article.solutionTag">
                                <div class="article-item__tag" v-if="article.marketTag">{{ article.marketTag }}</div>
                                <div class="article-item__tag" v-if="article.solutionTag">
                                    {{ article.solutionTag }}
                                </div>
                                <div class="article-item__tag" v-if="article.contentType">
                                    {{ article.contentType }}
                                </div>
                            </div>
                            <h3 class="article-item__headline">{{ article.Headline }}</h3>
                        </div>
                        <div class="article-item__link-text">{{ dictionary.ArticleLink }}</div>
                    </div>
                </a>
            </article>
        </li>
    </ul>
    <div class="articles-list__cta">
        <div class="articles-list__load-more" v-show="hasMoreArticles">
            <a @click="getNextPage" :disabled="isLoading">{{
                dictionary.ArticlesLoadMore
            }}</a>
        </div>
    </div>
</template>

<script>
import { bindRoute } from "./mixins/bindroute.js";
import ResponsiveImage from "./components/responsiveImage.vue";

const serviceUrl = "/umbraco/api/articlesApi/getArticles";
const defaultMarketTag = "All";
const defaultSolutionTag = "All";
const defaultContentType = "All";
export default {
    name: "Articles",
    components: {
        ResponsiveImage
    },
    data() {
        return {
            dictionary: [],
            markets: [],
            solutions: [],
            contentTypes: [],
            culture: "da-DK",
            articles: [],
            pageSize: 9,
            page: 1,
            totalArticles: 0,
            isLoading: false,
            hasLoadedInitials: false,
            articlesNodeId: 0,
            isResetting: false,
            showMarket: false,
            showContentType: false,
            showSolution: false
        };
    },
    mixins: [
        bindRoute({
            market: defaultMarketTag,
            solution: defaultSolutionTag,
            contentType: defaultContentType
        }),
    ],
    watch: {
        market: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        },
        solution: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        },
        contentType: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        }
    },
    mounted() {
        this.articlesNodeId = this.$parent.articlesNodeId;
        this.pageSize = this.$parent.pageSize;
        this.showMarket = this.$parent.showMarket === 'True';
        this.showSolution = this.$parent.showSolution === 'True';
        this.showContentType = this.$parent.showContentType === 'True';

        this.$router.isReady().then(() => {
            this.getInitialArticles();
        }).catch(error => {
            console.log(error);
        });
    },
    methods: {
        handleFilterPropertyChange(oldVal, newVal) {
            if (oldVal !== newVal) {
                if (this.hasLoadedInitials && !this.isResetting) {
                    this.filterChanged();
                }
            }
        },
        getArticles(amountToSkip, pageSize) {
            const vm = this,
                languageCode = document.querySelector("html").getAttribute("lang");
            vm.toggleSpinner(true);
            var object = {
                articlesNodeId: vm.articlesNodeId,
                languageCode: languageCode,
                amountToSkip: amountToSkip,
                pageSize: pageSize
            };

            if (vm.market != defaultMarketTag) {
                object.market = vm.market;
            }

            if (vm.solution != defaultSolutionTag) {
                object.solution = vm.solution;
            }

            if (vm.contentType != defaultContentType) {
                object.contentType = vm.contentType;
            }

            fetch(serviceUrl + "?" + new URLSearchParams(object))
                .then((response) => response.json())
                .then((data) => {
                    vm.articles.push(...data.Items);
                    vm.markets = data.Facets.Markets;
                    vm.solutions = data.Facets.Solutions;
                    vm.contentTypes = data.Facets.ContentTypes;
                    vm.dictionary = data.Dictionary;
                    vm.totalArticles = data.TotalItems;
                    vm.hasLoadedInitials = true;
                    vm.toggleSpinner(false);
                    vm.isResetting = false;
                })
                .catch((error) => {
                    console.log(error);
                    vm.toggleSpinner(false);
                });
        },
        getNextPage() {
            if (!this.isLoading) {
                this.page++;
                this.getArticles(this.pageSize * (this.page - 1), this.pageSize);
            }
        },
        getInitialArticles() {
            // Get all cases up to, and including, the current page
            const initialPageSize = this.pageSize * this.page;
            this.getArticles(0, initialPageSize);
        },
        filterChanged() {
            this.articles = [];
            this.totalArticles = 0;
            this.page = 1;
            this.getArticles(0, this.pageSize);
        },
        resetFilter() {
            const vm = this;
            vm.isResetting = true;
            vm.articles = [];
            vm.totalArticles = 0;
            vm.page = 1;
            vm.market = defaultMarketTag;
            vm.solution = defaultSolutionTag;
            vm.contentType = defaultContentType;

            vm.$router.replace({ path: window.location.pathname, query: {} })
                .then(() => {
                    vm.getArticles(0, vm.pageSize);
                })
                .catch(err => { console.log(err); });
        },
        toggleSpinner: function (isLoading) {
            this.isLoading = isLoading;
            const bodyElement = document.querySelector("body");
            if (isLoading) {
                bodyElement.classList.add("is-loading");
            } else {
                bodyElement.classList.remove("is-loading");
            }
        },
    },
    computed: {
        hasMoreArticles() {
            return (
                this.totalArticles !== 0 &&
                this.articles.length < this.totalArticles
            );
        },
        hasFilterApplied() {
            return this.market != defaultMarketTag ||
                this.solution != defaultSolutionTag ||
                this.contentType != defaultContentType;
        }
    },
};
</script>